import type { JobStatusResponse } from "@/types/previews";

export interface JobProgressPanelProps {
  readonly status: JobStatusResponse | null;
  readonly stopped: boolean;
  readonly error: Error | null;
}

export function JobProgressPanel({
  status,
  stopped,
  error,
}: JobProgressPanelProps): JSX.Element | null {
  if (!status) return null;
  const pct =
    status.total > 0 ? Math.round((status.completed / status.total) * 100) : 0;
  const terminal = stopped && !error;
  const barClass = terminal
    ? "progress-bar__fill progress-bar__fill--done"
    : "progress-bar__fill progress-bar__fill--running";
  return (
    <section
      className="theme-previews-page__job"
      aria-labelledby="job-panel-heading"
    >
      <header className="theme-previews-page__job-header">
        <h3 id="job-panel-heading">
          Job <code>{status.job_id}</code>
          {terminal ? (
            <span className="badge badge--fresh">Completed</span>
          ) : null}
        </h3>
      </header>
      <div
        className="progress-bar"
        role="progressbar"
        aria-valuenow={status.completed}
        aria-valuemin={0}
        aria-valuemax={status.total}
      >
        <div className={barClass} style={{ width: `${pct}%` }} />
      </div>
      <dl className="theme-previews-page__counters">
        <div>
          <dt>Total:</dt>
          <dd>{status.total}</dd>
        </div>
        <div>
          <dt>Completed:</dt>
          <dd>{status.completed}</dd>
        </div>
        <div>
          <dt>Generating:</dt>
          <dd>{status.generating}</dd>
        </div>
        <div>
          <dt>Failed:</dt>
          <dd>{status.failed}</dd>
        </div>
        <div>
          <dt>Pending:</dt>
          <dd>{status.pending}</dd>
        </div>
      </dl>
      {stopped && error ? (
        <div className="error-banner" role="alert">
          <span className="error-banner__icon" aria-hidden>
            ⚠
          </span>
          <div className="error-banner__content">
            <div className="error-banner__title">Polling stopped</div>
            <div className="error-banner__message">{error.message}</div>
          </div>
        </div>
      ) : null}
    </section>
  );
}
